import COMMON_SIT from "./db/commonSit.json";

/**
 * 資產類別 id ↔ 名稱：唯一來源是 SIT 錄下的 `/Common/AssetCategories`（db/commonSit.json）。
 * 「其他」是 99，不是第 5 個 —— 不要用陣列序位換算。畫面一律吃 API，這份只給 mock 用。
 */
const OPTIONS = COMMON_SIT.AssetCategories;

export const assetCategoryNameById = (id) => (OPTIONS.find((o) => o.value === Number(id)) || {}).text || "";
export const assetCategoryIdByName = (name) => (OPTIONS.find((o) => o.text === name) || {}).value || 0;
